module.exports = __webpack_public_path__ + "img/temperature_blue.3507768e.svg";